<template>
  <div class="notice">
    <div class="panel panel-default">
      <div class="panel-heading">
        <h4 class="panel-title"><span class="notice-img"><img :src="notice.src" alt=""></span>&nbsp;{{notice.title}}
          <template v-if=" num===2 ">
            <a href="purchase.html?num=2" class="pull-right a-more">更多&gt;</a>
          </template>
          <template v-if="morelink">
            <a target='_blank' :href="morelink" class="pull-right a-more">更多&gt;</a>
          </template>
        </h4>
      </div>
      <div class="panel-body min-height">
        <template v-if="notice.content">
          <div v-for="info in notice.content">
            <a href="javascript:;" :title="info.messageTitle||info.title" class="list-group-item list-padding"
               @click="detailed(info)"><span
              class="list-dot">·</span>&nbsp;{{info.messageTitle||info.title}}</a>
          </div>
        </template>
        <template v-else-if="!notice.content && notice.title!='友情链接'">
          <p class="notcie-error-handling">暂无数据</p>
        </template>
        <template v-if="notice.title=='友情链接'">
          <!-- <p class="friendlylink"><a href="http://www.yueyun.com/" target="_blank"><img src="static/imgs/logo_jg.png" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.mysteel.com/" target="_blank"><img src="static/imgs/wdgt.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.cfhi.com/yzjt/index.html" target="_blank"><img src="static/imgs/dyzxjx.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.shaangu.com/" target="_blank"><img src="static/imgs/sgdl.jpg" alt=""></a></p>
          <p class="friendlylink"><a href="http://www.ccmn.cn/" target="_blank"><img src="static/imgs/cjys.jpg" alt=""></a></p> -->
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .list-group-item {
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .notice-img {
    position: relative;
    top: -1px;
  }

  .a-more {
    font-size: 13px;
    color: #666666 !important;
    position: relative;
    top: 1px;
  }

  .a-more:hover {
    text-decoration: none;
    padding-bottom: 5px;
    border-bottom: 1px solid #1983D7;
    color: #1983D7 !important;
  }

  .notice .panel {
    border-radius: 0px;
  }

  .min-height {
    min-height: 247px;
  }

  .min-height > div {
    cursor: pointer;
  }

  .notcie-error-handling {
    text-align: center;
    margin-top: 80px;
  }

  .friendlylink img{
    width: 240px;
  }
</style>

<script>
  /*eslint-disable*/
  import {apiLinks} from '../api/links.js'
  export default {
    name: 'notice',
    props: {
      // 基础类型检测 （`null` 意思是任何类型都可以）
      type: '',
      apiUrl: '',
      num: '',
      ajaxType: '',
      morelink: ''
    },
    data () {
      return {
        notice: '',
        companyNotices: {
          src: 'static/imgs/companynotice.png',
          title: '企业公告',
          content: ''
        },
        biddingNotices: {
          src: 'static/imgs/bidnotice.png',
          title: '中标公告',
          content: ''
        },
        clarifyNotices: {
          src: 'static/imgs/clearnotice.png',
          title: '澄清公告',
          content: ''
        },
        links: {
          src: 'static/imgs/friendlinks.png',
          title: '友情链接',
          content: ''
        },
        lbNotices: {
          src: 'static/imgs/bidnotice.png',
          title: '流标公告',
          content: ''
        },
        cqNotices: {
          src: 'static/imgs/bidnotice.png',
          title: '澄清公告',
          content: ''
        }
      }
    },
    mounted: function () {
      this.staticData(this.type)
      if (this.apiUrl !== '') {
        this.getDate()
      }
    },
    methods: {
      getDate: function () {
        switch (this.ajaxType) {
          case 'get':
            this.$http.get(this.apiUrl).then(function (response) {
              this.notice.content = response.data.data.results
            }, function (response) {
            })
            break
          default:
            this.$http.jsonp(this.apiUrl, []).then(function (response) {
              this.notice.content = response.data[0]['result']
            }, function (response) {
            })
            break
        }
      },
      staticData: function (type) {
        switch (type) {
          case 'company':
            this.notice = this.companyNotices
            break
          case 'bidding':
            this.notice = this.biddingNotices
            break
          case 'clarify':
            this.notice = this.clarifyNotices
            break
          case 'links':
            this.notice = this.links
            break
          case 'lbnotice':
            this.notice = this.lbNotices
            break
          case 'cqnotice':
            this.notice = this.cqNotices
            break
          default:
            break
        }
      },
      detailed: function (info) {
        switch (this.type) {
          case 'company':
            window.open(apiLinks.details['company'] + info.id)
            break
          case 'lbnotice':
            window.open(apiLinks.details['lbNotice'] + info.msgId + '&enterpriseId=' + info.srcEnterpriseId)
            break
          case 'cqnotice':
            window.open(apiLinks.details['cqNotice'] + info.msgId + '&enterpriseId=' + info.srcEnterpriseId)
            break
          default:
            if (info.href) {
              window.open(info.href)
            } else {
              var url = ''
              switch (parseInt(info.messageTypeShow)) {
                case 5: // 物资
                  url = apiLinks.details['bidMsg'] + info.msgId
                  break;
                case 7: // 物流
                  url = apiLinks.details['bidMsg'] + info.msgId
                  break;
                case 13: // 工程
                  url = apiLinks.details['bidMsg'] + info.msgId
                  break;
                case 14: // 服务
                  url = apiLinks.details['bidMsg'] + info.msgId
                  break;
                case 10:
                  url = apiLinks.details['bidMsg2'] + info.msgId
                  break;
                case 17:
                  url = apiLinks.details['bidMsg3'] + info.msgId
                  break;
                default:
                  url = apiLinks.details['bidDetails'] + info.msgId
                  break
              }
              window.open(url)
            }
            break
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// notice.vue?14f7becb